// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2xUMx","content":"GlobalSearch_content__1aeM8"};